import axios from 'axios';
import store from '@/store';
import queryString from 'query-string';
import ConstCode from '@/common/constants/ConstCode';
import { debounce } from 'lodash';

const scrollIsLocked = (locked) => {
  document.getElementsByTagName('main')[0].style = `overflow:${locked ? 'hidden' : 'auto'}`;
};

const loading = () => {
  store.commit('layout/updateIsLoading', true);
  scrollIsLocked(true);
};
const loaded = debounce(() => {
  store.commit('layout/updateIsLoading', false);
  scrollIsLocked(false);
}, 500);

class ServiceExec {
  constructor() {
    let axiosInstance = axios.create();
    axiosInstance.interceptors.request.use(this.handleRequest);
    axiosInstance.interceptors.response.use(this.handleSuccess, this.handleError);

    axiosInstance.defaults.paramsSerializer = function (params) {
      return queryString.stringify(params, {
        arrayFormat: 'repeat',
        allowDots: true
      });
    };
    this.ServiceExec = axiosInstance;
  }

  async handleRequest(request) {
    if (!request.skipLoading) loading();
    const accessToken = store.getters['admin/accessToken'];
    if (!accessToken) return request;
    request.headers[ConstCode.LOGIN_TOKEN_NAME] = `${accessToken}`;

    return request;
  }
  async handleSuccess(response) {
    if (!response.config.skipLoading) loaded();
    return response;
  }
  async handleError(error) {
    if (!(error.response?.config ?? error.config)?.skipLoading) loaded();

    const { status } = error.response;
    if (status === 404) return Promise.resolve({ status: 404, data: '잘못된 요청입니다.' });
    return Promise.resolve(error.response);
  }

  status = {
    OK: 200,
    ERROR: 500,
    NOT_FOUNT: 404
  };

  get(path, params = {}, config = {}) {
    return this.ServiceExec.get(path, { ...config, params });
  }
  patch(path, payload) {
    return this.ServiceExec.request({
      method: 'PATCH',
      url: path,
      responseType: 'json',
      data: payload
    });
  }
  post(path, payload) {
    return this.ServiceExec.request({
      method: 'POST',
      url: path,
      responseType: 'json',
      data: payload
    });
  }

  postWithProgressBar(path, payload) {
    return this.ServiceExec.post(path, payload, {
      onUploadProgress: (progressEvent) => {
        let percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        store.commit('layout/setProgress', percentage);
      },
      header: {
        'Response-Type': 'application/json'
      }
    });
  }


  put(path, payload) {
    return this.ServiceExec.request({
      method: 'PUT',
      url: path,
      responseType: 'json',
      data: payload
    });
  }
  delete(path, payload) {
    payload = `${path}?${queryString.stringify(payload)}`;
    return this.ServiceExec.delete(payload);
  }
  queryPost(path, payload) {
    payload = `${queryString.stringify(payload)}`;
    return this.ServiceExec.request({
      method: 'POST',
      url: path,
      responseType: 'json',
      data: payload
    });
  }
  multiPost(path, payload) {
    return this.ServiceExec.request({
      headers: { 'Content-Type': 'multipart/form-data' },
      method: 'POST',
      url: path,
      responseType: 'json',
      data: payload
    });
  }
}

let instance;
const initialize = () => {
  if (!instance) instance = new ServiceExec();

  return instance;
};
export default initialize();
